import { Environment } from './environment.model';

// TODO: dns is a placeholder until the partner dashboard host is confirmed.
export const environment: Environment = {
  production: false,
  apiEndpoint: 'https://portal.partners.api.test.romulus.live',
  dns: 'https://partner-dashboard.test.romulus.live',
  dashboardUrl: 'https://dashboard.test.romulus.live/autologin',
  defaultLanguage: 'en',
  supportedLanguages: [
    { locale: 'it', name: 'Italiano' },
    { locale: 'en', name: 'English' },
  ],
};
